/** Minimal RFC4180-style CSV parser for CRM import (quoted fields, commas, newlines). */

export function parseCsv(text: string): { headers: string[]; rows: string[][] } {
  const rows: string[][] = [];
  let current: string[] = [];
  let field = "";
  let inQuotes = false;

  const pushField = () => {
    current.push(field);
    field = "";
  };
  const pushRow = () => {
    if (current.length === 1 && current[0] === "" && rows.length === 0) {
      current = [];
      return;
    }
    rows.push(current);
    current = [];
  };

  const src = text.replace(/^\uFEFF/, "");
  for (let i = 0; i < src.length; i += 1) {
    const ch = src[i];
    if (inQuotes) {
      if (ch === '"') {
        if (src[i + 1] === '"') {
          field += '"';
          i += 1;
        } else {
          inQuotes = false;
        }
      } else {
        field += ch;
      }
      continue;
    }
    if (ch === '"') {
      inQuotes = true;
      continue;
    }
    if (ch === ",") {
      pushField();
      continue;
    }
    if (ch === "\n") {
      pushField();
      pushRow();
      continue;
    }
    if (ch === "\r") {
      continue;
    }
    field += ch;
  }
  pushField();
  if (current.length > 1 || (current.length === 1 && current[0] !== "")) {
    pushRow();
  }

  const headers = (rows.shift() || []).map((h) => h.trim());
  const body = rows.filter((row) => row.some((cell) => cell.trim()));
  return { headers, rows: body };
}
